import Slider from '../components/Slider';
const Component = () => (
  <Slider
    t1={10 * 60 * 1000}
    t2={
      1 * 60 * 1000 /* BUG après t2, on attend t1 avant le changement d'image */
    }
  />
);

const path = '#diaporama';
import { FilmIcon as label } from '@/icons';

const description = 'Affiche le diaporama';

const Page = { Component, path, label, description };
export default Page;
